import { Component, ContentChildren, ElementRef, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-base-modal',
  imports: [MatIconModule, MatDialogActions, MatDialogContent],
  templateUrl: './base-modal.component.html',
  styleUrl: './base-modal.component.scss',
})
export class BaseModalComponent {
  @Input({ required: true }) dialogTitle = '';
  @Input({ required: false }) dialogSubTitle = '';
  @Output() closeEvent = new EventEmitter<void>();
  @ContentChildren('[panel-footer]') footerContent!: QueryList<ElementRef>;

  public onClose() {
    this.closeEvent.emit();
  }
}
